<template>
	<bsh-confirm-modal 
        :modal_id="modal_id" 
        :title="title" 
        :message="message" 
        @action="action()" 
        :btn="btn"
        :btnStyle="btnStyle">
    </bsh-confirm-modal>
</template>

<script>
    import bshMessage from './../messages/message.js';
	export default {
		props: [
            'modal_id',
            'dado_id',  // id do dado
            'title',    // Titulo do modal
            'message',  // Menssagem do modal
            'rota',     // Rota que será enviado o requisito 
            'btn',      // Mensagem que aparecerá no botão
            'btnStyle',  // Estilo do botão  
            'method'    // Methodo que a rota será enviada
        ],
		methods : {
			action(){
                if(this.method == 'put'){
                    axios.put(this.rota+this.dado_id)
                    .then(response => {
                      this.$emit('reload')
                      bshMessage.show(response.data.message, response.data.type)
                    })
                    .catch(error => (bshMessage.show('Ocorreu um erro inesperado!', 'error')));
                } 
                if(this.method == 'delete'){
                    axios.delete(this.rota+this.dado_id)
                    .then(response => {
                      this.$emit('reload')
                      bshMessage.show(response.data.message, response.data.type)
                    })
                    .catch(error => (bshMessage.show('Ocorreu um erro inesperado!', 'error')));
                }
			},
		},
	}
</script>